// (function (window, document) {
//   "use strict";

//   var STORAGE_KEY = "backyard_glove_recommendation";

//   var MODE_REDIRECTS = {
//   catcher: "/products/catcher-glove-custom",
//   outfield: "/products/outfield-glove-custom",
//   first_base: "/products/first-base-glove",
//   infield: "/products/infield-glove",
//   pitcher: "/products/pitcher-glove",
// };

//   var AGE_BANDS = [
//     { id: "3-5", min: 3, max: 5 },
//     { id: "6-7", min: 6, max: 7 },
//     { id: "8-10", min: 8, max: 10 },
//     { id: "11-12", min: 11, max: 12 },
//     { id: "13-14", min: 13, max: 14 },
//     { id: "15+", min: 15, max: 99 }
//   ];

//   var GLOVE_FINDER_DATA = {
//     catcher: {
//       sizes: ["32.5", "33", "33.5", "34", "35"]
//     },
//     outfield: {
//       sizes: ["12", "12.25", "12.5", "12.75", "13"],
//       webOptions: [
//         { id: "h-web", name: "H-Web" },
//         { id: "t-web", name: "T-Web" },
//         { id: "trapeze-web", name: "Trapeze Web" }
//       ]
//     },
//     first_base: {
//       sizes: ["12.5", "12.75", "13"],
//       webOptions: [
//         { id: "h-web", name: "H-Web" },
//         { id: "post-web", name: "Post Web" },
//         { id: "two-piece-web", name: "2 Piece Web" }
//       ]
//     },
//     infield: {
//       sizes: ["11.25", "11.5", "11.75", "12"],
//       webOptions: [
//         { id: "h-web", name: "H-Web" },
//         { id: "i-web", name: "I-Web" },
//         { id: "cross-web", name: "Cross Web" },
//         { id: "laced-cross", name: "Laced Cross" },
//         { id: "one-piece", name: "One Piece" },
//         { id: "post-web", name: "Post Web" }
//       ]
//     },
//     pitcher: {
//       sizes: ["11.5", "11.75", "12", "12.25"],
//       webOptions: [
//         { id: "basket", name: "Basket Web" },
//         { id: "basket-t", name: "Basket T-Web" },
//         { id: "double-v", name: "Double V Web" },
//         { id: "dual-hinge", name: "Dual Hinge" },
//         { id: "mod-loop", name: "Mod Loop" },
//         { id: "shield", name: "Shield Web" },
//         { id: "two-piece", name: "Two Piece" },
//         { id: "victory", name: "Victory Web" }
//       ]
//     },
//     // trainer: {
//     //   sizes: ["9.5 (Trainer)"],
//     //   webOptions: [
//     //     { id: "i-web", name: "I-Web" }
//     //   ]
//     }
//   };

//   var SIZE_TARGETS = {
//     outfield: { "3-5": 12.0, "6-7": 12.0, "8-10": 12.0, "11-12": 12.25, "13-14": 12.5, "15+": 12.75 },
//     infield: { "3-5": 11.25, "6-7": 11.25, "8-10": 11.25, "11-12": 11.5, "13-14": 11.75, "15+": 11.75 },
//     pitcher: { "3-5": 11.5, "6-7": 11.5, "8-10": 11.5, "11-12": 11.75, "13-14": 12.0, "15+": 12.0 },
//     first_base: { "3-5": 12.5, "6-7": 12.5, "8-10": 12.5, "11-12": 12.5, "13-14": 12.75, "15+": 13.0 },
//     catcher: { "3-5": 32.5, "6-7": 32.5, "8-10": 32.5, "11-12": 33.0, "13-14": 33.5, "15+": 34.0 },
//     // trainer: { "3-5": 9.5, "6-7": 9.5, "8-10": 9.5, "11-12": 9.5, "13-14": 9.5, "15+": 9.5 }
//   };

//   var WEB_RECOMMENDATIONS = {
//     outfield: {
//       quick_transfer: { recommended: "h-web", allowed: ["h-web", "t-web"] },
//       balanced: { recommended: "h-web", allowed: ["h-web", "t-web", "trapeze-web"] },
//       bigger_pocket: { recommended: "trapeze-web", allowed: ["trapeze-web", "h-web"] }
//     },
//     infield: {
//       quick_transfer: { recommended: "i-web", allowed: ["i-web", "post-web"] },
//       balanced: { recommended: "post-web", allowed: ["post-web", "h-web", "i-web"] },
//       bigger_pocket: { recommended: "h-web", allowed: ["h-web", "laced-cross", "cross-web"] }
//     },
//     pitcher: {
//       quick_transfer: { recommended: "basket", allowed: ["basket", "shield", "two-piece"] },
//       balanced: { recommended: "two-piece", allowed: ["basket", "two-piece", "shield", "basket-t"] },
//       bigger_pocket: { recommended: "shield", allowed: ["shield", "two-piece", "basket"] }
//     },
//     first_base: {
//       quick_transfer: { recommended: "post-web", allowed: ["post-web", "h-web"] },
//       balanced: { recommended: "h-web", allowed: ["h-web", "post-web", "two-piece-web"] },
//       bigger_pocket: { recommended: "two-piece-web", allowed: ["two-piece-web", "h-web"] }
//     }
//   };

//   function getAgeBand(age) {
//     var parsedAge = parseInt(age, 10);
//     if (isNaN(parsedAge)) return null;
//     for (var i = 0; i < AGE_BANDS.length; i += 1) {
//       if (parsedAge >= AGE_BANDS[i].min && parsedAge <= AGE_BANDS[i].max) return AGE_BANDS[i].id;
//     }
//     return null;
//   }

//   function normalizePosition(position) {
//     var raw = String(position || "").toLowerCase().trim();
//     if (raw === "catcher") return "catcher";
//     if (raw === "first_base" || raw === "first base" || raw === "1b") return "first_base";
//     if (raw === "pitcher" || raw === "p") return "pitcher";
//     if (raw === "outfield" || raw === "of") return "outfield";
//     // if (raw === "trainer") return "trainer";
//     return "infield";
//   }

//   function normalizePreference(preference) {
//     var raw = String(preference || "").toLowerCase().trim();
//     if (raw === "quick transfer" || raw === "quick_transfer") return "quick_transfer";
//     if (raw === "bigger pocket" || raw === "bigger_pocket") return "bigger_pocket";
//     return "balanced";
//   }

//   function parseSizeValue(sizeText) {
//     var parsed = parseFloat(String(sizeText || "").replace(/[^0-9.]/g, ""));
//     return isNaN(parsed) ? null : parsed;
//   }

//   function pickClosestSize(availableSizes, target) {
//     var best = availableSizes[0];
//     var bestDistance = Number.POSITIVE_INFINITY;
//     availableSizes.forEach(function (sizeText) {
//       var numericValue = parseSizeValue(sizeText);
//       var distance;
//       if (numericValue == null) return;
//       distance = Math.abs(numericValue - target);
//       if (distance < bestDistance) {
//         best = sizeText;
//         bestDistance = distance;
//       }
//     });
//     return best;
//   }

//   function getAllowedSizesForMode(availableSizes, recommendedSize) {
//     var recommendedValue = parseSizeValue(recommendedSize);
//     if (recommendedValue == null) return availableSizes.slice();
//     return availableSizes.filter(function (sizeText) {
//       var value = parseSizeValue(sizeText);
//       if (value == null) return false;
//       return Math.abs(value - recommendedValue) <= 0.25;
//     });
//   }

//   function recommendGlove(profile) {
//     var mode = normalizePosition(profile.primaryPosition);
//     var ageBand = getAgeBand(profile.age);
//     var preference = normalizePreference(profile.preference);
//     var modeConfig = GLOVE_FINDER_DATA[mode];
//     var targetSize;
//     var recommendedSize;
//     var allowedSizes;
//     var webRules;
//     var recommendedWebStyle = null;
//     var recommendedWebStyleName = null;
//     var allowedWebs = [];
//     var explanation;

//     if (!ageBand) throw new Error("Age is required.");
//     if (!modeConfig) throw new Error("No glove config found for mode: " + mode);

//     targetSize = SIZE_TARGETS[mode][ageBand];
//     recommendedSize = pickClosestSize(modeConfig.sizes, targetSize);
//     allowedSizes = getAllowedSizesForMode(modeConfig.sizes, recommendedSize);

//     if (modeConfig.webOptions && modeConfig.webOptions.length) {
//       webRules = (WEB_RECOMMENDATIONS[mode] && WEB_RECOMMENDATIONS[mode][preference]) || {
//         recommended: modeConfig.webOptions[0].id,
//         allowed: modeConfig.webOptions.map(function (option) { return option.id; })
//       };
//       recommendedWebStyle = webRules.recommended;
//       allowedWebs = webRules.allowed.slice();
//       recommendedWebStyleName = (modeConfig.webOptions.find(function (option) {
//         return option.id === recommendedWebStyle;
//       }) || {}).name || null;
//     }

//     explanation =
//       "We recommend a " +
//       recommendedSize +
//       "\" " +
//       mode.replace(/_/g, " ") +
//       " glove" +
//       (recommendedWebStyleName ? " with a " + recommendedWebStyleName : "") +
//       " for this player.";

//     return {
//       playerProfile: {
//         age: parseInt(profile.age, 10),
//         ageBand: ageBand,
//         primaryPosition: mode,
//         throwingHand: profile.throwingHand || "RHT",
//         skillLevel: profile.skillLevel || "beginner",
//         preference: preference
//       },
//       recommendedMode: mode,
//       recommendedSize: recommendedSize,
//       allowedSizes: allowedSizes,
//       recommendedWebStyle: recommendedWebStyle,
//       recommendedWebStyleName: recommendedWebStyleName,
//       allowedWebs: allowedWebs,
//       explanation: explanation,
//       redirectUrl: MODE_REDIRECTS[mode]
//     };
//   }

//   function applyRecommendationToMittState(recommendation, mittState) {
//     mittState.throw = recommendation.playerProfile.throwingHand;
//     mittState.size = recommendation.recommendedSize;
//     if (recommendation.recommendedWebStyle) mittState.webStyle = recommendation.recommendedWebStyle;
//     mittState.stiffness = recommendation.playerProfile.skillLevel === "advanced" ? "Brick" : "Standard";
//   }

//   function filterSizesForUI(activeConfig, recommendation) {
//     if (!recommendation || !recommendation.allowedSizes || recommendation.allowedSizes.length === 0) {
//       return activeConfig.sizes.slice();
//     }
//     return activeConfig.sizes.filter(function (sizeText) {
//       return recommendation.allowedSizes.indexOf(sizeText) >= 0;
//     });
//   }

//   function filterWebsForUI(activeConfig, recommendation) {
//     if (!activeConfig.webOptions) return [];
//     if (!recommendation || !recommendation.allowedWebs || recommendation.allowedWebs.length === 0) {
//       return activeConfig.webOptions.slice();
//     }
//     return activeConfig.webOptions.filter(function (option) {
//       return recommendation.allowedWebs.indexOf(option.id) >= 0;
//     });
//   }

//   window.BackyardGloveRecommendation = {
//     recommendGlove: recommendGlove,
//     applyRecommendationToMittState: applyRecommendationToMittState,
//     filterSizesForUI: filterSizesForUI,
//     filterWebsForUI: filterWebsForUI
//   };

//   var STEPS = [
//     { key: "age", prompt: "How old is the player?", type: "number", placeholder: "12" },
//     {
//       key: "primaryPosition",
//       prompt: "What position do they play most?",
//       type: "chips",
//       options: [
//         { label: "Outfield", value: "outfield" },
//         { label: "Infield", value: "infield" },
//         { label: "Pitcher", value: "pitcher" },
//         { label: "Catcher", value: "catcher" },
//         { label: "First Base", value: "first_base" }
//       ]
//     },
//     {
//       key: "throwingHand",
//       prompt: "Which hand do they throw with?",
//       type: "chips",
//       options: [
//         { label: "Right Hand Throw", value: "RHT" },
//         { label: "Left Hand Throw", value: "LHT" }
//       ]
//     },
//     {
//       key: "skillLevel",
//       prompt: "What level are they playing at?",
//       type: "chips",
//       options: [
//         { label: "Beginner", value: "beginner" },
//         { label: "Travel / Intermediate", value: "intermediate" },
//         { label: "Advanced / Elite", value: "advanced" }
//       ]
//     },
//     {
//       key: "preference",
//       prompt: "What matters more?",
//       type: "chips",
//       options: [
//         { label: "Quick Transfer", value: "quick_transfer" },
//         { label: "Balanced", value: "balanced" },
//         { label: "Bigger Pocket", value: "bigger_pocket" }
//       ]
//     }
//   ];

//   var state = { isOpen: false, hasStarted: false, stepIndex: 0, profile: {} };
//   var elements = {};

//   function injectStyles() {
//     if (document.getElementById("gf-widget-styles")) return;
//     var style = document.createElement("style");
//     style.id = "gf-widget-styles";
//     style.textContent =
//       ".gf-widget-bubble{position:fixed;right:20px;bottom:20px;z-index:99999;border:none;background:#000;color:#fff;padding:14px 18px;border-radius:999px;font:700 14px/1.2 Arial,sans-serif;cursor:pointer;box-shadow:0 12px 28px rgba(0,0,0,.2);}" +
//       ".gf-widget-panel{position:fixed;right:20px;bottom:78px;width:360px;max-width:calc(100vw - 24px);height:520px;max-height:70vh;background:#fff;border:2px solid #000;z-index:99999;display:none;flex-direction:column;box-shadow:0 16px 40px rgba(0,0,0,.22);}" +
//       ".gf-widget-panel.open{display:flex;}" +
//       ".gf-widget-header{padding:14px 16px;border-bottom:2px solid #000;background:#000;color:#fff;font:700 14px/1.3 Arial,sans-serif;display:flex;justify-content:space-between;align-items:center;}" +
//       ".gf-widget-close{background:none;border:none;color:#fff;font:700 18px/1 Arial,sans-serif;cursor:pointer;}" +
//       ".gf-widget-messages{flex:1;overflow:auto;padding:14px;background:#f6f6f6;}" +
//       ".gf-msg{margin:0 0 12px;max-width:88%;padding:10px 12px;border:2px solid #000;background:#fff;color:#000;font:14px/1.45 Arial,sans-serif;}" +
//       ".gf-msg.user{margin-left:auto;background:#000;color:#fff;}" +
//       ".gf-widget-actions{padding:12px;border-top:2px solid #000;background:#fff;}" +
//       ".gf-chip-list{display:flex;flex-wrap:wrap;gap:8px;}" +
//       ".gf-chip{border:2px solid #000;background:#fff;color:#000;padding:10px 12px;cursor:pointer;font:700 13px/1.2 Arial,sans-serif;}" +
//       ".gf-chip:hover{background:#000;color:#fff;}" +
//       ".gf-input-row{display:flex;gap:8px;}" +
//       ".gf-input{flex:1;border:2px solid #000;padding:10px 12px;font:14px Arial,sans-serif;}" +
//       ".gf-btn{border:2px solid #000;background:#000;color:#fff;padding:10px 12px;cursor:pointer;font:700 13px/1 Arial,sans-serif;width:100%;margin-top:8px;}" +
//       ".gf-secondary{background:#fff;color:#000;}";
//     document.head.appendChild(style);
//   }

//   function createElement(tagName, className, text) {
//     var node = document.createElement(tagName);
//     if (className) node.className = className;
//     if (text != null) node.textContent = text;
//     return node;
//   }

//   function addMessage(text, type) {
//     var message = createElement("div", "gf-msg" + (type === "user" ? " user" : ""), text);
//     elements.messages.appendChild(message);
//     elements.messages.scrollTop = elements.messages.scrollHeight;
//   }

//   function clearActions() {
//     elements.actions.innerHTML = "";
//   }

//   function toggleWidget(forceOpen) {
//     state.isOpen = typeof forceOpen === "boolean" ? forceOpen : !state.isOpen;
//     elements.panel.classList.toggle("open", state.isOpen);
//   }

//   function restartFlow() {
//     state.hasStarted = true;
//     state.stepIndex = 0;
//     state.profile = {};
//     elements.messages.innerHTML = "";
//     addMessage("Let's find the right glove for your player.", "bot");
//     renderStep();
//   }

//   function saveAnswer(step, value, label) {
//     state.profile[step.key] = value;
//     addMessage(label || String(value), "user");
//     state.stepIndex += 1;
//     if (state.stepIndex >= STEPS.length) {
//       finishFlow();
//       return;
//     }
//     renderStep();
//   }

//   function renderStep() {
//     var step = STEPS[state.stepIndex];
//     clearActions();
//     addMessage(step.prompt, "bot");

//     if (step.type === "number") {
//       var row = createElement("div", "gf-input-row");
//       var input = createElement("input", "gf-input");
//       var button = createElement("button", "gf-btn", "Next");
//       input.type = "number";
//       input.min = "3";
//       input.max = "18";
//       input.placeholder = step.placeholder || "";
//       button.addEventListener("click", function () {
//         if (!input.value) return;
//         saveAnswer(step, input.value, input.value + " years old");
//       });
//       input.addEventListener("keydown", function (event) {
//         if (event.key === "Enter") button.click();
//       });
//       row.appendChild(input);
//       row.appendChild(button);
//       elements.actions.appendChild(row);
//       return;
//     }

//     var chipList = createElement("div", "gf-chip-list");
//     step.options.forEach(function (option) {
//       var chip = createElement("button", "gf-chip", option.label);
//       chip.type = "button";
//       chip.addEventListener("click", function () {
//         saveAnswer(step, option.value, option.label);
//       });
//       chipList.appendChild(chip);
//     });
//     elements.actions.appendChild(chipList);
//   }

//   function finishFlow() {
//     clearActions();
//     var recommendation = recommendGlove(state.profile);
//     sessionStorage.setItem(STORAGE_KEY, JSON.stringify(recommendation));
//     addMessage(recommendation.explanation, "bot");

//     var openButton = createElement("button", "gf-btn", "Open Recommended Glove");
//     openButton.type = "button";
//     openButton.addEventListener("click", function () {
//       var glue = recommendation.redirectUrl.indexOf("?") === -1 ? "?" : "&";
//       window.location.href = recommendation.redirectUrl + glue + "gf=1";
//     });

//     var restartButton = createElement("button", "gf-btn gf-secondary", "Start Over");
//     restartButton.type = "button";
//     restartButton.addEventListener("click", restartFlow);

//     elements.actions.appendChild(openButton);
//     elements.actions.appendChild(restartButton);
//   }

//   function buildWidget() {
//     var bubble = createElement("button", "gf-widget-bubble", "Need help choosing a glove?");
//     var panel = createElement("div", "gf-widget-panel");
//     var header = createElement("div", "gf-widget-header");
//     var title = createElement("div", "", "Glove Finder");
//     var close = createElement("button", "gf-widget-close", "×");
//     var messages = createElement("div", "gf-widget-messages");
//     var actions = createElement("div", "gf-widget-actions");

//     bubble.type = "button";
//     close.type = "button";

//     close.addEventListener("click", function () {
//       toggleWidget(false);
//     });

//     bubble.addEventListener("click", function () {
//       toggleWidget(true);
//       if (!state.hasStarted) restartFlow();
//     });

//     header.appendChild(title);
//     header.appendChild(close);
//     panel.appendChild(header);
//     panel.appendChild(messages);
//     panel.appendChild(actions);

//     document.body.appendChild(bubble);
//     document.body.appendChild(panel);

//     elements = { bubble: bubble, panel: panel, messages: messages, actions: actions };
//   }

//   function init() {
//     injectStyles();
//     buildWidget();
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", init);
//   } else {
//     init();
//   }
// })(window, document);

(function (window, document) {
  "use strict";

  var STORAGE_KEY = "backyard_glove_recommendation";

  var MODE_REDIRECTS = {
    catcher: "/products/catcher-glove-custom",
    outfield: "/products/outfield-glove-custom",
    first_base: "/products/first-base-glove",
    infield: "/products/infield-glove",
    pitcher: "/products/pitcher-glove"
  };

  var AGE_BANDS = [
    { id: "3-5", min: 3, max: 5 },
    { id: "6-7", min: 6, max: 7 },
    { id: "8-10", min: 8, max: 10 },
    { id: "11-12", min: 11, max: 12 },
    { id: "13-14", min: 13, max: 14 },
    { id: "15+", min: 15, max: 99 }
  ];

  var GLOVE_FINDER_DATA = {
    catcher: {
      sizes: ["32.5", "33", "33.5", "34", "35"]
    },
    outfield: {
      sizes: ["12", "12.25", "12.5", "12.75", "13"],
      webOptions: [
        { id: "h-web", name: "H-Web" },
        { id: "t-web", name: "T-Web" },
        { id: "trapeze-web", name: "Trapeze Web" }
      ]
    },
    first_base: {
      sizes: ["12.5", "12.75", "13"],
      webOptions: [
        { id: "h-web", name: "H-Web" },
        { id: "post-web", name: "Post Web" },
        { id: "two-piece-web", name: "2 Piece Web" }
      ]
    },
    infield: {
      sizes: ["11.25", "11.5", "11.75", "12"],
      webOptions: [
        { id: "h-web", name: "H-Web" },
        { id: "i-web", name: "I-Web" },
        { id: "cross-web", name: "Cross Web" },
        { id: "laced-cross", name: "Laced Cross" },
        { id: "one-piece", name: "One Piece" },
        { id: "post-web", name: "Post Web" }
      ]
    },
    pitcher: {
      sizes: ["11.5", "11.75", "12", "12.25"],
      webOptions: [
        { id: "basket", name: "Basket Web" },
        { id: "basket-t", name: "Basket T-Web" },
        { id: "double-v", name: "Double V Web" },
        { id: "dual-hinge", name: "Dual Hinge" },
        { id: "mod-loop", name: "Mod Loop" },
        { id: "shield", name: "Shield Web" },
        { id: "two-piece", name: "Two Piece" },
        { id: "victory", name: "Victory Web" }
      ]
    },
    trainer: {
      sizes: ["9.5 (Trainer)"],
      webOptions: [
        { id: "i-web", name: "I-Web" }
      ]
    }
  };

  var SIZE_TARGETS = {
    outfield: { "3-5": 12.0, "6-7": 12.0, "8-10": 12.0, "11-12": 12.25, "13-14": 12.5, "15+": 12.75 },
    infield: { "3-5": 11.25, "6-7": 11.25, "8-10": 11.25, "11-12": 11.5, "13-14": 11.75, "15+": 11.75 },
    pitcher: { "3-5": 11.5, "6-7": 11.5, "8-10": 11.5, "11-12": 11.75, "13-14": 12.0, "15+": 12.0 },
    first_base: { "3-5": 12.5, "6-7": 12.5, "8-10": 12.5, "11-12": 12.5, "13-14": 12.75, "15+": 13.0 },
    catcher: { "3-5": 32.5, "6-7": 32.5, "8-10": 32.5, "11-12": 33.0, "13-14": 33.5, "15+": 34.0 },
    trainer: { "3-5": 9.5, "6-7": 9.5, "8-10": 9.5, "11-12": 9.5, "13-14": 9.5, "15+": 9.5 }
  };

  var WEB_RECOMMENDATIONS = {
    outfield: {
      quick_transfer: { recommended: "h-web", allowed: ["h-web", "t-web"] },
      balanced: { recommended: "h-web", allowed: ["h-web", "t-web", "trapeze-web"] },
      bigger_pocket: { recommended: "trapeze-web", allowed: ["trapeze-web", "h-web"] }
    },
    infield: {
      quick_transfer: { recommended: "i-web", allowed: ["i-web", "post-web"] },
      balanced: { recommended: "post-web", allowed: ["post-web", "h-web", "i-web"] },
      bigger_pocket: { recommended: "h-web", allowed: ["h-web", "laced-cross", "cross-web"] }
    },
    pitcher: {
      quick_transfer: { recommended: "basket", allowed: ["basket", "shield", "two-piece"] },
      balanced: { recommended: "two-piece", allowed: ["basket", "two-piece", "shield", "basket-t"] },
      bigger_pocket: { recommended: "shield", allowed: ["shield", "two-piece", "basket"] }
    },
    first_base: {
      quick_transfer: { recommended: "post-web", allowed: ["post-web", "h-web"] },
      balanced: { recommended: "h-web", allowed: ["h-web", "post-web", "two-piece-web"] },
      bigger_pocket: { recommended: "two-piece-web", allowed: ["two-piece-web", "h-web"] }
    }
  };

  function getAgeBand(age) {
    var parsedAge = parseInt(age, 10);
    if (isNaN(parsedAge)) return null;
    for (var i = 0; i < AGE_BANDS.length; i += 1) {
      if (parsedAge >= AGE_BANDS[i].min && parsedAge <= AGE_BANDS[i].max) return AGE_BANDS[i].id;
    }
    return null;
  }

  function normalizePosition(position) {
    var raw = String(position || "").toLowerCase().trim();
    if (raw === "catcher") return "catcher";
    if (raw === "first_base" || raw === "first base" || raw === "1b") return "first_base";
    if (raw === "pitcher" || raw === "p") return "pitcher";
    if (raw === "outfield" || raw === "of") return "outfield";
    if (raw === "trainer") return "trainer";
    return "infield";
  }

  function normalizePreference(preference) {
    var raw = String(preference || "").toLowerCase().trim();
    if (raw === "quick transfer" || raw === "quick_transfer") return "quick_transfer";
    if (raw === "bigger pocket" || raw === "bigger_pocket") return "bigger_pocket";
    return "balanced";
  }

  function parseSizeValue(sizeText) {
    var parsed = parseFloat(String(sizeText || "").replace(/[^0-9.]/g, ""));
    return isNaN(parsed) ? null : parsed;
  }

  function pickClosestSize(availableSizes, target) {
    var best = availableSizes[0];
    var bestDistance = Number.POSITIVE_INFINITY;
    availableSizes.forEach(function (sizeText) {
      var numericValue = parseSizeValue(sizeText);
      var distance;
      if (numericValue == null) return;
      distance = Math.abs(numericValue - target);
      if (distance < bestDistance) {
        best = sizeText;
        bestDistance = distance;
      }
    });
    return best;
  }

  function getAllowedSizesForMode(availableSizes, recommendedSize) {
    var recommendedValue = parseSizeValue(recommendedSize);
    if (recommendedValue == null) return availableSizes.slice();
    return availableSizes.filter(function (sizeText) {
      var value = parseSizeValue(sizeText);
      if (value == null) return false;
      return Math.abs(value - recommendedValue) <= 0.25;
    });
  }

  function recommendGlove(profile) {
    var mode = normalizePosition(profile.primaryPosition);
    var ageBand = getAgeBand(profile.age);
    var preference = normalizePreference(profile.preference);
    var modeConfig = GLOVE_FINDER_DATA[mode];
    var targetSize;
    var recommendedSize;
    var allowedSizes;
    var webRules;
    var recommendedWebStyle = null;
    var recommendedWebStyleName = null;
    var allowedWebs = [];
    var explanation;

    if (!ageBand) throw new Error("Age is required.");
    if (!modeConfig) throw new Error("No glove config found for mode: " + mode);

    targetSize = SIZE_TARGETS[mode][ageBand];
    recommendedSize = pickClosestSize(modeConfig.sizes, targetSize);
    allowedSizes = getAllowedSizesForMode(modeConfig.sizes, recommendedSize);

    if (modeConfig.webOptions && modeConfig.webOptions.length) {
      webRules = (WEB_RECOMMENDATIONS[mode] && WEB_RECOMMENDATIONS[mode][preference]) || {
        recommended: modeConfig.webOptions[0].id,
        allowed: modeConfig.webOptions.map(function (option) { return option.id; })
      };
      recommendedWebStyle = webRules.recommended;
      allowedWebs = webRules.allowed.slice();
      recommendedWebStyleName = (modeConfig.webOptions.find(function (option) {
        return option.id === recommendedWebStyle;
      }) || {}).name || null;
    }

    explanation =
      "We recommend a " +
      recommendedSize +
      "\" " +
      mode.replace(/_/g, " ") +
      " glove" +
      (recommendedWebStyleName ? " with a " + recommendedWebStyleName : "") +
      " for this player.";

    return {
      playerProfile: {
        age: parseInt(profile.age, 10),
        ageBand: ageBand,
        primaryPosition: mode,
        throwingHand: profile.throwingHand || "RHT",
        skillLevel: profile.skillLevel || "beginner",
        preference: preference
      },
      recommendedMode: mode,
      recommendedSize: recommendedSize,
      allowedSizes: allowedSizes,
      recommendedWebStyle: recommendedWebStyle,
      recommendedWebStyleName: recommendedWebStyleName,
      allowedWebs: allowedWebs,
      explanation: explanation,
      redirectUrl: MODE_REDIRECTS[mode]
    };
  }

  function applyRecommendationToMittState(recommendation, mittState) {
    mittState.throw = recommendation.playerProfile.throwingHand;
    mittState.size = recommendation.recommendedSize;
    if (recommendation.recommendedWebStyle) mittState.webStyle = recommendation.recommendedWebStyle;
    mittState.stiffness = "0";
  }

  function filterSizesForUI(activeConfig, recommendation) {
    if (!recommendation || !recommendation.allowedSizes || recommendation.allowedSizes.length === 0) {
      return activeConfig.sizes.slice();
    }
    return activeConfig.sizes.filter(function (sizeText) {
      return recommendation.allowedSizes.indexOf(sizeText) >= 0;
    });
  }

  function filterWebsForUI(activeConfig, recommendation) {
    if (!activeConfig.webOptions) return [];
    if (!recommendation || !recommendation.allowedWebs || recommendation.allowedWebs.length === 0) {
      return activeConfig.webOptions.slice();
    }
    return activeConfig.webOptions.filter(function (option) {
      return recommendation.allowedWebs.indexOf(option.id) >= 0;
    });
  }

  window.BackyardGloveRecommendation = {
    recommendGlove: recommendGlove,
    applyRecommendationToMittState: applyRecommendationToMittState,
    filterSizesForUI: filterSizesForUI,
    filterWebsForUI: filterWebsForUI
  };

  var STEPS = [
    { key: "age", prompt: "How old is the player?", type: "number", placeholder: "12" },
    {
      key: "primaryPosition",
      prompt: "What position do they play most?",
      type: "chips",
      options: [
        { label: "Outfield", value: "outfield" },
        { label: "Infield", value: "infield" },
        { label: "Pitcher", value: "pitcher" },
        { label: "Catcher", value: "catcher" },
        { label: "First Base", value: "first_base" }
      ]
    },
    {
      key: "throwingHand",
      prompt: "Which hand do they throw with?",
      type: "chips",
      options: [
        { label: "Right Hand Throw", value: "RHT" },
        { label: "Left Hand Throw", value: "LHT" }
      ]
    },
    {
      key: "skillLevel",
      prompt: "What level are they playing at?",
      type: "chips",
      options: [
        { label: "Beginner", value: "beginner" },
        { label: "Travel / Intermediate", value: "intermediate" },
        { label: "Advanced / Elite", value: "advanced" }
      ]
    },
    {
      key: "preference",
      prompt: "What matters more?",
      type: "chips",
      options: [
        { label: "Quick Transfer", value: "quick_transfer" },
        { label: "Balanced", value: "balanced" },
        { label: "Bigger Pocket", value: "bigger_pocket" }
      ]
    }
  ];

  var state = { isOpen: false, hasStarted: false, stepIndex: 0, profile: {} };
  var elements = {};

  function injectStyles() {
    if (document.getElementById("gf-widget-styles")) return;
    var style = document.createElement("style");
    style.id = "gf-widget-styles";
    style.textContent =
      ".gf-widget-bubble{position:fixed;right:20px;bottom:20px;z-index:99999;border:none;background:#000;color:#fff;padding:14px 18px;border-radius:999px;font:700 14px/1.2 Arial,sans-serif;cursor:pointer;box-shadow:0 12px 28px rgba(0,0,0,.2);}" +
      ".gf-widget-panel{position:fixed;right:20px;bottom:78px;width:360px;max-width:calc(100vw - 24px);height:520px;max-height:70vh;background:#fff;border:2px solid #000;z-index:99999;display:none;flex-direction:column;box-shadow:0 16px 40px rgba(0,0,0,.22);}" +
      ".gf-widget-panel.open{display:flex;}" +
      ".gf-widget-header{padding:14px 16px;border-bottom:2px solid #000;background:#000;color:#fff;font:700 14px/1.3 Arial,sans-serif;display:flex;justify-content:space-between;align-items:center;}" +
      ".gf-widget-close{background:none;border:none;color:#fff;font:700 18px/1 Arial,sans-serif;cursor:pointer;}" +
      ".gf-widget-messages{flex:1;overflow:auto;padding:14px;background:#f6f6f6;}" +
      ".gf-msg{margin:0 0 12px;max-width:88%;padding:10px 12px;border:2px solid #000;background:#fff;color:#000;font:14px/1.45 Arial,sans-serif;}" +
      ".gf-msg.user{margin-left:auto;background:#000;color:#fff;}" +
      ".gf-widget-actions{padding:12px;border-top:2px solid #000;background:#fff;}" +
      ".gf-chip-list{display:flex;flex-wrap:wrap;gap:8px;}" +
      ".gf-chip{border:2px solid #000;background:#fff;color:#000;padding:10px 12px;cursor:pointer;font:700 13px/1.2 Arial,sans-serif;}" +
      ".gf-chip:hover{background:#000;color:#fff;}" +
      ".gf-input-row{display:flex;gap:8px;align-items:stretch;}" +
      ".gf-input{flex:1 1 0;min-width:0;min-height:44px;border:2px solid #000;padding:10px 12px;font:14px Arial,sans-serif;}" +
      ".gf-btn{border:2px solid #000;background:#000;color:#fff;padding:10px 12px;cursor:pointer;font:700 13px/1 Arial,sans-serif;width:100%;margin-top:8px;min-height:44px;display:flex;align-items:center;justify-content:center;}" +
      ".gf-input-row .gf-btn{flex:1 1 0;width:auto;margin-top:0;}" +
      ".gf-secondary{background:#fff;color:#000;}";
    document.head.appendChild(style);
  }

  function createElement(tagName, className, text) {
    var node = document.createElement(tagName);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function addMessage(text, type) {
    var message = createElement("div", "gf-msg" + (type === "user" ? " user" : ""), text);
    elements.messages.appendChild(message);
    elements.messages.scrollTop = elements.messages.scrollHeight;
  }

  function clearActions() {
    elements.actions.innerHTML = "";
  }

  function toggleWidget(forceOpen) {
    state.isOpen = typeof forceOpen === "boolean" ? forceOpen : !state.isOpen;
    elements.panel.classList.toggle("open", state.isOpen);
  }

  function restartFlow() {
    state.hasStarted = true;
    state.stepIndex = 0;
    state.profile = {};
    elements.messages.innerHTML = "";
    addMessage("Let's find the right glove for your player.", "bot");
    renderStep();
  }

  function saveAnswer(step, value, label) {
    state.profile[step.key] = value;
    addMessage(label || String(value), "user");
    state.stepIndex += 1;
    if (state.stepIndex >= STEPS.length) {
      finishFlow();
      return;
    }
    renderStep();
  }

  function renderStep() {
    var step = STEPS[state.stepIndex];
    clearActions();
    addMessage(step.prompt, "bot");

    if (step.type === "number") {
      var row = createElement("div", "gf-input-row");
      var input = createElement("input", "gf-input");
      var button = createElement("button", "gf-btn", "Next");
      input.type = "number";
      input.min = "3";
      input.max = "18";
      input.placeholder = step.placeholder || "";
      button.addEventListener("click", function () {
        if (!input.value) return;
        saveAnswer(step, input.value, input.value + " years old");
      });
      input.addEventListener("keydown", function (event) {
        if (event.key === "Enter") button.click();
      });
      row.appendChild(input);
      row.appendChild(button);
      elements.actions.appendChild(row);
      return;
    }

    var chipList = createElement("div", "gf-chip-list");
    step.options.forEach(function (option) {
      var chip = createElement("button", "gf-chip", option.label);
      chip.type = "button";
      chip.addEventListener("click", function () {
        saveAnswer(step, option.value, option.label);
      });
      chipList.appendChild(chip);
    });
    elements.actions.appendChild(chipList);
  }

  function finishFlow() {
    clearActions();
    var recommendation = recommendGlove(state.profile);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(recommendation));
    addMessage(recommendation.explanation, "bot");

    var openButton = createElement("button", "gf-btn", "Open Recommended Glove");
    openButton.type = "button";
    openButton.addEventListener("click", function () {
      var glue = recommendation.redirectUrl.indexOf("?") === -1 ? "?" : "&";
      window.location.href = recommendation.redirectUrl + glue + "gf=1";
    });

    var restartButton = createElement("button", "gf-btn gf-secondary", "Start Over");
    restartButton.type = "button";
    restartButton.addEventListener("click", restartFlow);

    elements.actions.appendChild(openButton);
    elements.actions.appendChild(restartButton);
  }

  function buildWidget() {
    var bubble = createElement("button", "gf-widget-bubble", "Need help choosing a glove?");
    var panel = createElement("div", "gf-widget-panel");
    var header = createElement("div", "gf-widget-header");
    var title = createElement("div", "", "Glove Finder");
    var close = createElement("button", "gf-widget-close", "×");
    var messages = createElement("div", "gf-widget-messages");
    var actions = createElement("div", "gf-widget-actions");

    bubble.type = "button";
    close.type = "button";

    close.addEventListener("click", function () {
      toggleWidget(false);
    });

    bubble.addEventListener("click", function () {
      toggleWidget(true);
      if (!state.hasStarted) restartFlow();
    });

    header.appendChild(title);
    header.appendChild(close);
    panel.appendChild(header);
    panel.appendChild(messages);
    panel.appendChild(actions);

    document.body.appendChild(bubble);
    document.body.appendChild(panel);

    elements = { bubble: bubble, panel: panel, messages: messages, actions: actions };
  }

  function init() {
    injectStyles();
    buildWidget();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(window, document);
